// frontend/src/pages/admin/AdminLayout.tsx
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from '@utils/constants';

const NAV: { to: string; label: string }[] = [
  { to: ROUTES.ADMIN_DASHBOARD, label: 'Dashboard' },
  { to: ROUTES.ADMIN_TENANTS, label: 'Tenants' },
  { to: ROUTES.ADMIN_USERS, label: 'Users' },
  { to: ROUTES.ADMIN_SYSTEM_LOGS, label: 'System Logs' },
  { to: ROUTES.ADMIN_AUDIT_LOGS, label: 'Audit Logs' },
  { to: ROUTES.ADMIN_SHOWCASE, label: 'Showcase' },
];

const AdminLayout: React.FC = () => (
  <div className="min-h-screen bg-gray-50">
    <div className="mx-auto flex max-w-7xl flex-col md:flex-row">
      <aside className="w-full flex-shrink-0 border-b border-gray-200 bg-white py-4 md:w-56 md:border-b-0 md:border-r md:py-6">
        <h2 className="px-4 text-xs font-semibold uppercase tracking-wide text-gray-400 md:px-6">
          Admin
        </h2>
        <nav className="mt-3 flex gap-1 overflow-x-auto px-2 md:mt-4 md:block md:space-y-1 md:px-0">
          {NAV.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `block whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium md:rounded-none md:px-6 ${
                  isActive
                    ? 'bg-indigo-50 text-indigo-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="min-w-0 flex-1">
        <Outlet />
      </main>
    </div>
  </div>
);

export default AdminLayout;
